module.exports = __webpack_public_path__ + "img/jhPageBg.11a5de12.png";